import React from 'react'
import { Request } from '@services/models'
import * as pageUtils from './__index.utils'
import { formatStrapiText } from '@utils/methods'

type propsType = {
	request: Request
	pageData: any
}

const PersonalInfoSection: React.FC<propsType> = ({ request, pageData }) => {
	return (
		<>
			<p className={pageUtils.classes.paragraph}>
				<b>
					{' '}
					{formatStrapiText(pageData.assets?.myRequest_collapse_full_name)}{' '}
				</b>
				<br />
				{request.incidentForm?.applicant?.firstName}{' '}
				{request.incidentForm?.applicant?.lastName}
			</p>

			<p className={pageUtils.classes.paragraph}>
				<b> {formatStrapiText(pageData.assets?.label_email)} </b>
				<br />
				{request.incidentForm?.applicant?.email}
			</p>

			<p className={pageUtils.classes.paragraph}>
				<b> {formatStrapiText(pageData.assets?.label_address)} </b>
				<br />
				{request.incidentForm?.applicant?.address}
				<br />
				{request.incidentForm?.applicant?.city}{' '}
				{/* // @TODO: ajouter `state` dans l'objet IApplicant  */}
				{/* {' (QC) '}´´ */}
				{!!request.incidentForm?.applicant?.postalCode &&
					request.incidentForm?.applicant?.postalCode !== 'none' &&
					request.incidentForm?.applicant?.postalCode}
				<br />
				{request.incidentForm?.applicant?.apartment
					? `${formatStrapiText(pageData.assets?.label_apartment_office)} ${
							request.incidentForm?.applicant?.apartment
					  }`
					: ''}
			</p>

			<p className={pageUtils.classes.paragraph}>
				<b> {formatStrapiText(pageData.assets?.label_telephone)} </b>
				<br />
				{request.incidentForm?.applicant?.telephone ||
					request.incidentForm?.applicant?.telephone_evening ||
					request.incidentForm?.applicant?.telephone_other}
				<br />
				{request.incidentForm?.applicant?.telephone_extension && (
					<>Poste {request.incidentForm?.applicant?.telephone_extension}</>
				)}
			</p>

			<br />
		</>
	)
}

export default PersonalInfoSection
